import BuyingFilter from "../../components/filteration/buyingFilter";
import ShopAdds from "../../components/shopAds/ShopAdds";
import Shops from "../../components/Multipleshopprofile/Components/Shops/Shops";
import { Container, Row, Col } from "react-bootstrap";
import { useState, useEffect, useContext } from "react";
import ShareModel from "../../components/Sharemodel";
import ShareOption from "../../components/Shareoption";
import BackArrow from "../../components/backArrow";
import { ShopContext } from "../../config/shopContext";
import { useGetShopCategoriesQuery, useLazyGetShopCategoriesQuery, useLazyGetFilteredShopsQuery } from "../../features/shop/shopApiSlice";

const RecycleOnline = () => {
  const shopType = "recycledShop"; // unique context identifier
  const { getFilteredData, updateFilteredData } = useContext(ShopContext);
  const currentData = getFilteredData(shopType);

  const [isloading, setIsloading] = useState(false);
  const [createshopcategory, setCreateshopcategory] = useState([]);
  const [shopCategory, setShopCategory] = useState([]);
  const [shopCategorytwo, setShopCategorytwo] = useState([]);
  const [showmodal, setShowmodal] = useState(false);
  const [showshare, setShowshare] = useState(false);
  const [dataCategory, setDataCategory] = useState({ categoryid: "" });

  const [shopdata, setShopdata] = useState(currentData.shopdata || []);
  const [itemmdata, setItemmdata] = useState(currentData.itemmdata || []);
  const [filters, setFilters] = useState(currentData.additionalData || {
    id: "",
    shopid: "",
    shopname: "",
    itemname: "",
    marketPlace: "",
    categoryid: "",
    subCategoryid: "",
    shopCategory: "",
    country: "",
    state: "",
    city: "",
    specialoffer: "",
    salespromotion: "",
    min: "",
    max: "",
    sale: ""
  });

  // Modal & Share handlers
  const handleClosemodal = () => setShowmodal(false);
  const handleShow = () => setShowmodal(true);
  const handleCloseshare = () => { setShowshare(false); setShowmodal(true); };
  const handleShowshare = () => setShowshare(true);

  // Handle category selection
  const Handledata = (e) => {
    setDataCategory(prev => ({ ...prev, [e.target.name]: e.target.value.split(".") }));
  };

  const categoryName = dataCategory?.categoryid?.[1];
  const categoryidone = dataCategory?.categoryid?.[0];

  useEffect(() => {
    setFilters(prev => ({ ...prev, categoryid: categoryidone || "" }));
  }, [categoryidone]);

  const { data: catResMain } = useGetShopCategoriesQuery({ type: 'recycledShop', parentCategory: '' });
  const { data: catResTrue } = useGetShopCategoriesQuery({ type: 'recycledShop', parentCategory: 'true' });
  const [getSubCategories] = useLazyGetShopCategoriesQuery();

  // Fetch main shop categories
  useEffect(() => {
    if (catResMain?.success) setCreateshopcategory(catResMain.data.Category);
  }, [catResMain]);

  useEffect(() => {
    if (catResTrue?.success) setShopCategory(catResTrue.data.Category);
  }, [catResTrue]);

  // Fetch subcategories based on selected category
  const Mydata = () => {
    if (categoryName) {
      getSubCategories({ type: 'recycledShopItem', parentCategory: categoryName })
        .unwrap()
        .then(res => {
          if (res?.success) setShopCategorytwo(res.data.Category);
        })
        .catch(err => console.log(err));
    }
  };

  // Handle filter input changes
  const HandleFilters = (e) => {
    setFilters(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  // Build query string for shop/item filtering
  const buildQuery = (type) => {
    let query = { businessType: shopType, filtermethod: type };
    const keys = type === "shop"
      ? ["shopname","shopCategory","marketPlace","shopid","specialoffer","sale","categoryid"]
      : ["itemname","categoryid","subCategoryid","country","state","city","specialoffer","salespromotion","min","max"];

    keys.forEach(k => { if(filters[k] && filters[k].trim() !== "") query[k] = filters[k].trim(); });
    return new URLSearchParams(query).toString();
  };

  const [getFilteredShops, { isLoading: isFilterLoading }] = useLazyGetFilteredShopsQuery();

  const FilterHandler = () => {
    const newFilters = { ...filters, itemname:"", categoryid:"", subCategoryid:"", country:"", state:"", city:"", salespromotion:"", min:"", max:"" };
    setFilters(newFilters);
    setShopdata([]);
    setItemmdata([]);

    const queryParams = Object.fromEntries(new URLSearchParams(buildQuery("shop")));

    getFilteredShops(queryParams)
      .unwrap()
      .then(res => {
        if(res?.success || res?.Shop || res?.ShopItem){
          setShopdata(res.Shop || []);
          setItemmdata(res.ShopItem || []);
          updateFilteredData(shopType, res.Shop || [], res.ShopItem || [], newFilters);
        }
      }).catch((err) => console.log(err));
  };

  const FilterHandlerItem = () => {
    const newFilters = { ...filters, shopname:"", shopCategory:"", marketPlace:"", shopid:"", specialoffer:"", sale:"" };
    setFilters(newFilters);
    setShopdata([]);
    setItemmdata([]);

    const queryParams = Object.fromEntries(new URLSearchParams(buildQuery("shopitem")));

    getFilteredShops(queryParams)
      .unwrap()
      .then(res => {
        if(res?.success || res?.Shop || res?.ShopItem){
          setShopdata(res.Shop || []);
          setItemmdata(res.ShopItem || []);
          updateFilteredData(shopType, res.Shop || [], res.ShopItem || [], newFilters);
        }
      }).catch((err) => console.log(err));
  };

  return (
    <>
      <ShareOption showshare={showshare} handleCloseshare={handleCloseshare} />
      <ShareModel showmodal={showmodal} handleClosemodal={handleClosemodal} handleShowshare={handleShowshare} />
      <Container>
        <BackArrow back="/BuyingSide" mystyle="buying-page-mobile-back d-lg-none" />
        <Row className="buying-page-row">
          <Col lg="4" className="screenHeight background-image">
            <div className="border b-radius height_100">
              <BuyingFilter
                Handleadditioanalshop={HandleFilters}
                FilterHandler={FilterHandler}
                FilterHandleritem={FilterHandlerItem}
                dataCategory={dataCategory}
                createshopcategory={createshopcategory}
                shopCategory={shopCategory}
                Handledata={Handledata}
                shopCategorytwo={shopCategorytwo}
                Mydata={Mydata}
                additionalShopCategoryData={filters}
              />
            </div>
          </Col>
          <Col lg="8" className="screenHeight">
            <div className="border b-radius ps-2 pe-2">
              <BackArrow back="/BuyingSide" mystyle="ps-2 pt-1 d-none d-lg-block" />
              <ShopAdds />
              <Shops
                link="/Recycleuserprofile"
                title="Recycle Materials"
                isloading={isloading || isFilterLoading}
                data={0}
                handleShow={handleShow}
                shopdata={shopdata}
                itemmdata={itemmdata}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default RecycleOnline;
